import React from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';
import { useParams, useNavigate } from 'react-router-dom';
import { TeamBuilder } from '../components/teams/TeamBuilder';
import { TeamCreate, TeamUpdate } from '../types/team';
import * as teamService from '../services/teamService';

export const TeamEdit: React.FC = () => {
  const { teamId } = useParams<{ teamId: string }>();
  const navigate = useNavigate();
  
  const { data: team, isLoading, error } = useQuery(
    ['team', teamId],
    () => teamService.getTeam(teamId)
  );
  
  const updateTeamMutation = useMutation(
    (teamData: TeamUpdate) => teamService.updateTeam(teamId, teamData),
    {
      onSuccess: () => {
        navigate(`/teams/${teamId}`);
      }
    }
  );
  
  const handleSaveTeam = (teamData: TeamCreate) => {
    const updateData: TeamUpdate = {
      name: teamData.name,
      description: teamData.description,
      roster_id: teamData.roster_id,
      leader_persona: teamData.leader_persona,
      goal: teamData.goal,
      tags: teamData.tags,
      workflow: teamData.workflow
    };
    
    updateTeamMutation.mutate(updateData);
  };
  
  if (isLoading) {
    return <div className="text-center py-10">Loading team...</div>;
  }
  
  if (error) {
    return <div className="text-center py-10 text-red-600">Error loading team</div>;
  }
  
  if (!team) {
    return <div className="text-center py-10 text-red-600">Team not found</div>;
  }
  
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Edit Team: {team.name}</h1>
      </div>
      
      {updateTeamMutation.isError && (
        <div className="mb-6 p-4 bg-red-100 text-red-700 rounded-md">
          Error updating team: {updateTeamMutation.error.message}
        </div>
      )}
      
      <TeamBuilder 
        initialTeam={{
          name: team.name,
          description: team.description,
          roster_id: team.roster_id,
          leader_persona: team.leader_persona,
          goal: team.goal,
          workflow: team.workflow,
          tags: team.tags
        }} 
        onSave={handleSaveTeam} 
      />
    </div>
  );
};
